import React, {FC, PropsWithChildren} from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {UnnormalizedProps} from '@yosmanyga/core-style';
import {Button, Container, I18NText, Icon, useIcons} from '@yosmanyga/rich-ui';
import {RestartController} from '../controller';

const Restart = observer(({
    templates,
    onRestart,
    onCancel,
}: RestartProps) => {
    const icons = useIcons();

    const controller = useService(RestartController, []);

    return <templates.layout
        flow="column"
        align={{
            cross: 'center',
        }}
        padding={{
            top: 4,
        }}
    >
        <I18NText>Start again from the beginning?</I18NText>
        <Container
            flow="row"
            align={{
                main: 'center',
                cross: 'center',
            }}
            margin={{
                top: 1,
            }}
        >
            <Button
                intent='secodary'
                onClick={onCancel}
            >
                <Icon
                    component={icons.actions.back}
                    size='xxs'
                />
                <I18NText>No, cancel</I18NText>
            </Button>
            <Button
                intent='negative'
                margin={{
                    left: 1,
                }}
                progress={controller.restarting}
                onClick={async () => {
                    // This action will delete the language and that will lead to a re-render
                    // and show again the home page
                    await controller.restart();

                    // Needed on web to navigate to home
                    onRestart && onRestart();
                }}
            >
                <Icon
                    component={icons.actions.restart}
                    size='xxs'
                />
                <I18NText>Yes, restart</I18NText>
            </Button>
        </Container>
    </templates.layout>
});

type RestartProps = {
    templates: {
        layout: FC<PropsWithChildren & UnnormalizedProps>;
    };
    onRestart?: () => void;
    onCancel: () => void;
}

export type {
    RestartProps,
}

export {
    Restart
};
